import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export interface DeleteBookmarkRequest {
  dashboardId: string | null
}

export const ZBookmark = z
  .object({
    dashboardId: z.string().optional(),
    message: z.string()
  })
  .optional()
export const ZData = ZBookmark

export const ZApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.optional(ZData)
})

export type DeleteBookmarkResponce = z.infer<typeof ZData>
export type DeleteBookmarkResponceAPIData = z.infer<typeof ZApiResponse>

export async function deleteBookmarkService (
  bookmarkId: string,
  onSuccess: (DeleteBookmarkResponce: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any,
  onReset: () => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/bookmark/${bookmarkId}`
  interceptedAxios
    .delete(url, { timeout: 10000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      onSuccess({}, 200)
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
    .finally(() => {
      onReset()
    })
}
